import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=4cfc7888"
import script from "./SaveButton.vue?vue&type=script&lang=js"
export * from "./SaveButton.vue?vue&type=script&lang=js"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=4cfc7888&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports